export default {
  methods: {
    loadRetailers(url, params) {
      let errorText = 'there was an error loading retailers'
      this.$api.get(url, params)
        .then((response) => {
          const data = response.data
          if (data && typeof data !== 'string') {
            this.configureRetailers(response.data)
            this.setRetailerLoadErrors()
          } else {
            if (this.totalPageCount) { this.totalPageCount = null }
            this.setRetailerLoadErrors(`${errorText}, please refresh or contact support`)
          }
        })
        .catch((error) => {
          if (this.totalPageCount) { this.totalPageCount = null }
          this.setRetailerLoadErrors(`${errorText}: ${error}`)
        })
    },

    setRetailerLoadErrors(message) {
      if (this.setErrors) {
        this.setErrors('retailersApi', message)
      } else {
        this.$emit('setRetailerErrors', message)
      }
    }
  },
}